if (!customElements.get('before-after-slider')) {
  customElements.define(
    'before-after-slider',
    class BeforeAfterSlider extends HTMLElement {
      constructor() {
        super();
        this.handle = this.querySelector('.door-gallery__handle');
        this.dragging = false;

        this.handle.addEventListener('pointerdown', this.startDrag.bind(this));
        this.addEventListener('pointermove', this.drag.bind(this));
        this.addEventListener('pointerup', this.stopDrag.bind(this));
        this.addEventListener('pointerleave', this.stopDrag.bind(this));
        this.handle.addEventListener('keydown', this.onKeydown.bind(this));

        this.setPosition(50);
      }

      startDrag(event) {
        this.dragging = true;
        this.handle.setPointerCapture(event.pointerId);
        this.drag(event);
      }

      drag(event) {
        if (!this.dragging) return;
        const rect = this.getBoundingClientRect();
        const percent = ((event.clientX - rect.left) / rect.width) * 100;
        this.setPosition(percent);
      }

      stopDrag() {
        this.dragging = false;
      }

      onKeydown(event) {
        const step = event.shiftKey ? 10 : 2;
        if (event.key === 'ArrowLeft') {
          this.setPosition(this.position - step);
        } else if (event.key === 'ArrowRight') {
          this.setPosition(this.position + step);
        } else {
          return;
        }
        event.preventDefault();
      }

      setPosition(percent) {
        this.position = Math.min(100, Math.max(0, percent));
        this.style.setProperty('--slider-pos', `${this.position}%`);
        this.handle.setAttribute('aria-valuenow', Math.round(this.position));
      }
    }
  );
}
